import { Plugin } from 'prosemirror-state';

import { EditorOptions } from '@lyearn/lygo-core';

function plugins(_editorOptions: EditorOptions): Plugin[] {
  return [];
}

export default plugins;
